import React from "react";

const VideoSec = () => {
    return (
        <div className="course-structure glance-sec">
            <div className="course-structure__content">
                <h2 className="title">ویدئو معرفی اساتید</h2>
                <br/>
                <div className="teachers-video-sec">
                        <video style={{width: '100%'}} src={"/video/teachers.mp4"} muted autoPlay controls>
                        </video>
                </div>
            </div>
        </div>
    );
};

export default VideoSec;
